import { render, staticRenderFns } from "./scientist.vue?vue&type=template&id=dda14422&scoped=true"
import script from "./scientist.vue?vue&type=script&lang=js"
export * from "./scientist.vue?vue&type=script&lang=js"
import style0 from "./scientist.vue?vue&type=style&index=0&id=dda14422&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda14422",
  null
  
)

export default component.exports